import type { FmSeriesColor } from './chartTypes';
import {
  paletteAssortment,
  paletteEconomics,
  paletteSeries,
  paletteSpecies,
  paletteTone,
} from './palette';

/** Resolve a series colour descriptor; species codes outside the table throw. */
export function resolveSeriesColor(color: FmSeriesColor): string {
  switch (color.by) {
    case 'species':
      return paletteSpecies(color.code);
    case 'assortment':
      return paletteAssortment(color.key);
    case 'economics':
      return paletteEconomics(color.key);
    case 'tone':
      return paletteTone(color.tone);
    case 'sequence':
      return paletteSeries(color.index);
  }
}
